// src/components/Inquiry/utils/filterItemsByType.ts
import { CartItemType } from "types/CartTypes";
import { OrderItemType } from "types/OrderTypes";
import { InquiryTypeEnum } from "types/InquiryTypes";
import { CartType } from "types/CartTypes";
import { OrderType } from "types/OrderTypes";
import { ManufacturedProductDetailsType } from "types/products/ProductCommandsType";
import { MANUFACTURED_PART_TYPES } from "pages/outsourcing_management/requisitions/partEligibility";

/**
 * Pure function — no side effects. Filters order/cart items by inquiry type.
 * Extracted from the old handleType callback.
 */
export function filterItemsByType(
  prodObj: OrderType | CartType | undefined,
  type: InquiryTypeEnum
): (OrderItemType | CartItemType)[] {
  if (!prodObj) return [];

  const result: (OrderItemType | CartItemType)[] = [];

  for (const item of prodObj.items) {
    const prodType = item.product.productType;

    if (
      type === InquiryTypeEnum.CNC ||
      type === InquiryTypeEnum.PRINT3D ||
      type === InquiryTypeEnum.SHEET
    ) {
      if (prodType.toString() === type.toString()) {
        result.push(item);
      }
    } else if (type === InquiryTypeEnum.FINISH) {
      const details = item.product.details as ManufacturedProductDetailsType;
      // details.finish is typed as string[] but is actually a comma-separated string at runtime
      const finish = details?.finish as unknown as string;
      if (finish != null && finish !== "standard") {
        result.push(item);
      }
    } else if (type === InquiryTypeEnum.CUSTOM) {
      // Only the parts we make can be sent out to be worked on - the same
      // allowlist the requisition part pickers use. An OTHER line is bought in
      // and has no model or drawing to send.
      if (MANUFACTURED_PART_TYPES.includes(prodType)) {
        result.push(item);
      }
    }
    // MATERIAL, PROCESSED_RAW_MATERIAL and TOOL list nothing from the order. Their lines are the
    // requisition's own (an OTHER product each), and the material email only
    // renders those, so a part ticked here was saved and never reached the
    // supplier.
  }

  return result;
}
